<template>
    <div id="ujoy_plus_div">
        <Title class="ujoy_plus_course_title"
               :title="'佑＋成长套餐 | '"
               :description="'佑佐特色专题课程，导师助教全程辅导，最优最快成长'"
               :more="'plus'"
        >
        </Title>
        <v-loader :source="index_louplus">
            <div class="item_card">
                <Card class="ujoy_plus_card"
                      v-for="(data, index) in index_louplus "
                      :key="index"
                      :data="data"
                >

                </Card>

            </div>
        </v-loader>
    </div>
</template>

<script type="text/javascript">
import Title from './sub_components/title.vue'
import Card from '../common_components/cards/lou_plus_card.vue'

import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            index_louplus: state => state.home.home_content.index_louplus.slice(0,4)
        })
    },
    components: {
      Title,
      Card
    }
}
</script>

<style type="text/css" scoped>
#ujoy_plus_div {
    display: flex;
    flex-direction: column;
    width: 1150px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px 15px 0 0;
    background: #f7f7f7;
    margin-bottom: 30px;
}

.ujoy_plus_course_title {
    margin-bottom: 30px;
}

.item_card {
    display: flex;
    justify-content: space-around;
    padding: 0 15px;
}

.ujoy_plus_card {
    width: 25%;
    box-sizing: border-box;
    padding-right: 19px;
}

</style>
